import React, { useState, useEffect } from 'react';
import Switch from 'react-switch';
import api from '@utils/axiosInstance';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast, Flip } from 'react-toastify';

function SubLangStateSwitch({ language, setAvailableSubtitleLanguages, setSubtitleLanguageStates, setCurrentSelectedLanguage }) {
    // Use language.state directly to initialize the state
    const [state, setState] = useState(language.state === 1);

    const { t } = useTranslation();
    const { uuid } = useParams();
    const userToken = useSelector(state => state.organization.userToken);
    const organizationData = useSelector(state => state.organization.organizationData);

    // Update internal state whenever language.state changes
    useEffect(() => {
        console.log('language.state', language)
        setState(language.state === 1);
    }, [language.state]);

    const handleStateChange = () => {
        const newState = !state;

        setState(newState);

        // 동시에 subtitleLanguageStates 상태를 업데이트
        setSubtitleLanguageStates(prevStates => ({
            ...prevStates,
            [language.lang]: newState
        }));

        api({
            method: 'post',
            url: '/subtitle/setState',
            data: {
                tk: userToken,
                uuid,
                ogc: organizationData.organization_code,
                type: language.lang,
                state: newState
            }
        })
            .then(response => {
                console.log('response', response.data.lang, typeof response.data.lang)
                if (response.data.code === 100) {
                    setAvailableSubtitleLanguages(prevLanguages => {
                        const updatedLanguages = prevLanguages.map(item =>
                            item.lang === language.lang ? { ...item, state: newState ? 1 : 0 } : item
                        );
                        console.log('updatedLanguages', updatedLanguages, prevLanguages)

                        // 현재 선택된 언어가 변경된 언어와 동일한 경우 상태 업데이트
                        setCurrentSelectedLanguage(prevSelected => {
                            if (prevSelected && prevSelected.lang === language.lang) {
                                return { ...prevSelected, state: newState ? 1 : 0 };
                            }
                            return prevSelected;
                        });

                        return updatedLanguages;
                    });
                } else {
                    setState(!newState);
                    // API 실패 시 subtitleLanguageStates도 원래대로 되돌림
                    setSubtitleLanguageStates(prevStates => ({
                        ...prevStates,
                        [language.lang]: !newState
                    }));
                    toast.error("자막 상태를 변경하는 데 실패했습니다.", {
                        position: "top-center",
                        transition: Flip
                    });
                }
            })
            .catch(error => {
                setState(!newState);
                setSubtitleLanguageStates(prevStates => ({
                    ...prevStates,
                    [language.lang]: !newState
                }));
                console.error('Error updating language state:', error);
            });
    };

    return (
        <Switch
            checked={state}
            onChange={handleStateChange}
            width={40}
            height={20}
        />
    );
}

export default SubLangStateSwitch;